export const MAX_VISIBLE_TIEMS = 9
